import React from 'react';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import app from '../../firebase_config';
import axios from 'axios';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import OtpInput from 'otp-input-react';
import { USER_API, DevMode } from '../../functions';
import { MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
import 'react-phone-number-input/style.css'
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import 'react-toastify/dist/ReactToastify.css';
import lottie from 'lottie-web';
import "./index.css";
import Swal from 'sweetalert2';
// -----------------------------------------------------------------------------------------


const UserInput = ({ CTA, name, type, currentValue, callback, disabled = false }) => {
  return (
    <div>
      <label htmlFor={name} className="block text-sm font-medium leading-6 text-gray-900">
        {CTA}
      </label>
      <div className="mt-2">
        <input
          id={name}
          name={name}
          type={type}
          value={currentValue}
          autoComplete="off"
          onChange={(e) => {
            callback(e.target.value);
          }}
          required={true}
          className="block w-full rounded-md text-sm p-3 border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
    </div>
  )
}

const MobileInput = ({ callback, disabled, currentValue, otpCallback, resendBtn }) => {
  return (
    <div>
      <label htmlFor="number" className="block text-sm font-medium leading-6 text-gray-900 m-1">
        Mobile Number
      </label>
      <PhoneInput
        placeholder="Enter phone number"
        value={currentValue}
        onChange={callback}
        style={{ padding: "0.5rem", fontSize: "1rem" }}
        defaultCountry="IN"
        className="block w-full rounded-md text-sm p-3 border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
      />
      {resendBtn ? <ResendOtpTimer callback={otpCallback} /> : null}
    </div>
  )
}


const ResendOtpTimer = ({ callback }) => {
  const [seconds, setSeconds] = useState(45);
  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);
    }
  }, [seconds]);
  return (
    <div className='flex space-x-[50%] m-3 p-1'>
      {seconds === 0 ? <p
        onClick={() => {
          callback();
          setSeconds(45);
        }}
        className='text-sm text-indigo-600 cursor-pointer underline'
      >
        Resend OTP
      </p> : null}
      <p className="text-sm text-gray-500 relative ">Resend OTP in {seconds} seconds</p>
    </div>
  )
}


const Button = ({ CTA, callback }) => {
  return (
    <div>
      <button
        onClick={() => {
          callback();
        }}
        className="flex w-full justify-center rounded-md bg-indigo-600 p-2 text-sm  font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        {CTA}
      </button>
    </div>
  )
}



const Login = () => {

  const navigate = useNavigate();
  const ref = useRef(null);



  const [number, setNumber] = useState("");
  const [dob, setDOB] = useState("");
  const [verify, setVerify] = useState(false);
  const [otp, setOTP] = useState("");
  const [resendBtn, setResendBtn] = useState(false);
  const [loading, setLoading] = useState(false);

  const auth = getAuth(app);

  const checkUser = async () => {
    const user = Cookies.get('user');
    if (user) {
      try {
        let res = await axios.get(`${USER_API}/getData/${user}`);
        if (res.status === 200) {
          if (res.data.ifAdmin) {
            navigate('/Admin/');
          }
          else {
            navigate('/');
          }
        }
        else {
          Cookies.remove('user');
        }
      } catch (err) {
        Cookies.remove('user');
      }
    }
  }

  const Loader = () => {
    useEffect(() => {
      const Animator = lottie.loadAnimation({
        container: ref.current,
        animationData: require('../../Components/Animations/LoginVerification.json'),
        renderer: 'svg',
        loop: true,
        autoplay: true,

      });
      return () => Animator.destroy();
    }, [])

    return (
      <div className='flex justify-center items-center h-screen'>
        <div ref={ref} className='w-[min(90vw,40rem)]'></div>
        <h2 className='text-2xl font-semibold text-gray-700'>Verifying...</h2>
      </div>
    );

  }


  useEffect(() => {
    if (!DevMode) {
      onCaptchaVerify();
    }
    checkUser();
  }, [])


  const onCaptchaVerify = () => {
    if (window.recaptchaVerifier == null) {
      window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
        'size': 'invisible',
        'callback': (response) => {

        },
        'expired-callback': () => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Recaptcha Expired!',
          })
        }
      }, auth);
    }

  }


  const onSigninSubmit = () => {
    const phoneNumber = number;
    const appVerifier = window.recaptchaVerifier;

    signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((confirmationResult) => {
        toast.info('OTP has been sent !, Check out your mobile device', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });
        setResendBtn(true);

        window.confirmationResult = confirmationResult;
        // ...
      }).catch((error) => {
        toast.error('Something Went Wrong', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        console.log(error);
      });
  }

  const VerifyCode = async () => {
    setLoading(true);
    if (DevMode) {
      handleVerifyOTP();
      return;
    }
    try {
      const result = await window.confirmationResult.confirm(otp);
      // if code is correct
      if (result.user) {
        handleVerifyOTP();
      }
      else {
        toast.error('Something went wrong with Google Firebase', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
    }
    catch (error) {
      if (error.code === "auth/invalid-verification-code") {
        toast.error('OTP provided by you is Wrong, Retry Again !!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else {
        toast.error('Something went wrong with Google Firebase', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      console.log(error);
      toast.error('Edit the details if required and try again later', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }


  }

  const handleGetOTP = () => {
    if (number === "" || dob === "") {
      toast.warn('Please fill all the fields', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    if (!DevMode && !isPossiblePhoneNumber(number)) {
      toast.warn('Please enter a valid phone number', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    setVerify(true);
    if (!DevMode) {
      onSigninSubmit();
    }
  }


  const handleVerifyOTP = async () => {

    const data = {
      "StudentMobile": number,
      "StudentDOB": dob,
    }
    try {

      const response = await axios.post(`${USER_API}/entry`, data);
      Cookies.set('user', response.data.token, { expires: 30 });


      if (response.status == 201) {
        localStorage.setItem("user", JSON.stringify(response.data.message));
        navigate("/register");
      }
      else if (response.status === 200) {
        localStorage.setItem("user", JSON.stringify(response.data.message));
        if (response.data.message.ifAdmin) {
          navigate("/Admin/");
        }
        toast.success('Welcome user to Testing Portal', {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate("/");
      }
      else if (response.status === 304) {
        toast.error('Empty Fields', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else if (response.status === 422) {
        console.log(response.data.message);
        toast.error('Wrong Date of Birth and Mobile Number', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else {
        toast.error('Something went wrong !!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
    catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Wrong Details, edit them or try again later !!',
      }).then(() => {
        // refresh the page
        window.location.reload();
      })
    }
  }

  return (
    <div>
      {loading ? <Loader /> : (
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-6 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto w-40"
              src={require(`../../assets/MainLogo.webp`)}
            />
            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Student Dashboard Login
            </h2>
          </div>

          <MDBContainer className="p-1">

            <MDBRow>

              <MDBCol col='10' md='6'>
                <img src={require(`../../assets/LoginPageImage.webp`)} className="img-fluid " alt="login" />
              </MDBCol>

              <MDBCol col='4' md='6' className='my-5 flex flex-col'>

                <div className="space-y-14 my-5 text-sm" >
                  <UserInput
                    CTA="Date of Birth"
                    name="date"
                    type="date"
                    currentValue={dob}
                    callback={setDOB}
                    disabled={verify}
                  />

                  <MobileInput
                    currentValue={number}
                    callback={setNumber}
                    disabled={verify}
                    otpCallback={onSigninSubmit}
                    resendBtn={resendBtn}
                  />

                  {verify && (
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900 m-2">
                        Enter OTP
                      </label>
                      <OtpInput
                        value={otp}
                        onChange={(e) => { setOTP(e) }}
                        OTPLength={6}
                        otpType="number"
                        disabled={false}
                        className="opt-container"
                      ></OtpInput>
                    </div>
                  )}
                  <div>
                    {verify ? (
                      <Button
                        CTA="Verify OTP"
                        callback={VerifyCode}
                      />
                    ) : (
                      <Button
                        CTA="Send OTP"
                        callback={handleGetOTP}
                      />
                    )}
                  </div>
                </div>
              </MDBCol>

            </MDBRow>

          </MDBContainer>
          <div id="recaptcha-container">
          </div>
        </div>
      )}
    </div>
  )
}

export default Login